import ownerDocument from 'dom-helpers/ownerDocument';
import safeFindDOMNode from './safeFindDOMNode';
export default (function (componentOrElement) {
  return ownerDocument(safeFindDOMNode(componentOrElement));
});


//////////////////
// WEBPACK FOOTER
// ../~/react-overlays/esm/ownerDocument.js
// module id = 3051
// module chunks = 121